import { convertPotentialStringToNumber } from './number';

export const ensureBoolean = (
  value: any,
  whiteList = [],
  defaultValue: boolean | null | undefined = undefined
): boolean => {
  if (typeof value === 'boolean' || whiteList.includes(value)) {
    return value;
  }

  return defaultValue;
};

export const ensureNumber = (
  value: any,
  whiteList = [],
  defaultValue: number | null | undefined = undefined
): number => {
  if (typeof value === 'number' || whiteList.includes(value)) {
    return value;
  }

  const convertedValue = convertPotentialStringToNumber(value);

  return convertedValue ?? defaultValue;
};

export const ensureInteger = (
  value: any,
  whiteList = [],
  defaultValue: number | null | undefined = undefined
): number => {
  if (typeof value === 'number') {
    return parseInt(value.toString());
  }
  if (whiteList.includes(value)) {
    return value;
  }

  return defaultValue;
};

export const ensureString = (
  value: any,
  allowEmpty = true,
  whiteList = [],
  defaultValue: string | null | undefined = undefined
): string => {
  if (
    (typeof value === 'string' && (allowEmpty || value !== '')) ||
    whiteList.includes(value)
  ) {
    return value;
  }

  return defaultValue;
};

export const ensureStringOrNumber = (
  value: any,
  allowEmpty = true,
  whiteList = [],
  defaultValue: string | null | undefined = undefined
) => {
  if (
    (typeof value === 'string' && (allowEmpty || value !== '')) ||
    typeof value === 'number' ||
    whiteList.includes(value)
  ) {
    return value;
  }

  return defaultValue;
};
